/*
 * 사이트의 모든 문구는 이 파일에서 관리합니다. { ko, en } 쌍으로 적고,
 * 문자열 안에서 **굵게**, ==강조== 표기를 쓸 수 있습니다(components/Rich.js).
 * 경력 문구는 이력서(resume_ko.md / resume_en.md)와 같게 유지합니다.
 */

export const profile = {
  nameKo: '이은성',
  nameEn: 'Eunseong Lee',
  title: 'Business Analyst',
  tagline: {
    ko: '숫자로 말하고\n==결과로 증명==합니다.',
    en: 'I speak in numbers\nand ==prove it with results==.',
  },
  intro: {
    ko: '광고·배달·이커머스 현장에서 **4년 이상** 데이터로 문제를 정의하고 실행까지 연결해 왔습니다. 지금은 **지마켓**에서 전사 주간 경영보고서와 지표 변동의 원인 분석을 맡고 있습니다.',
    en: 'For **4+ years** across advertising, delivery, and e-commerce, I have turned data into problem definitions and executed solutions. Today I own the company-wide weekly business review and the root-cause analysis of KPI movements at **Gmarket**.',
  },
  email: 'silver7castle@gmail.com',
  phone: '010-2828-9373',
  linkedin: 'https://www.linkedin.com/in/eunseong-lee-silvercastle/',
  resume: {
    ko: '/kor_resume_eunseong.pdf',
    en: '/eng_resume_eunseong.pdf',
  },
};

export const about = {
  story: {
    ko: '현재 **지마켓 Business Analytics**에서 전사 주간 경영보고서(WBR)를 Excel에서 웹 대시보드로 전환해 SQL 추출부터 대시보드 개발·CI/CD까지 전담하고 있습니다. 주간 지표에 이상 신호가 보이면 조직·카테고리·셀러·채널 단위로 분해해 원인을 찾고, 상품 운영과 배송·할인 정책을 분석해 관리 지표와 대응 시나리오를 만듭니다.\n\n쿠팡이츠에서는 이상 패턴 주문 식별 로직에 머신러닝을 도입해 ==동일한 운영 인력으로 2.6배의 주문==을 처리할 수 있게 했고, 버즈빌에서는 SQL 분석 기반 지면 전략과 단가 최적화로 ==광고 매출 75% 성장==을 만들었습니다.\n\n연세대학교 언더우드국제대학에서 창의기술경영과 사학을 전공했고, 영어 말하기·듣기·읽기·쓰기 모두 최상 수준(TOEIC 990, OPIc AL)으로 글로벌 협업 경험이 있습니다.',
    en: 'At **Gmarket Business Analytics**, I migrated the company-wide weekly business review (WBR) from Excel to a web dashboard and own it end to end, from SQL extraction to dashboard development and CI/CD. When weekly KPIs show an anomaly, I break it down by organization, category, seller, and channel to find the cause, and I analyze catalog operations and shipping and discount policies to build management metrics and response scenarios.\n\nAt Coupang Eats, I added machine learning to anomaly-pattern order detection so ==the same operations team could handle 2.6× the orders==. At Buzzvil, SQL-driven inventory strategy and pricing optimization delivered ==75% ad revenue growth==.\n\nI studied Creative Technology Management and History at Yonsei University’s Underwood International College, and I work fluently in English (TOEIC 990, OPIc AL) with experience collaborating across global teams.',
  },
  education: [
    {
      period: '2012.03 — 2018.02',
      name: { ko: '연세대학교 · 언더우드국제대학', en: 'Yonsei University · Underwood International College' },
      note: {
        ko: '창의기술경영 / 사학 전공 (이학사 / 문학사)',
        en: 'B.S. in Creative Technology Management / B.A. in History',
      },
    },
  ],
  certifications: [
    { date: '2025.07', name: { ko: '빅데이터분석기사', en: 'Big Data Analysis Engineer' }, note: 'BAE' },
    { date: '2020.06', name: { ko: 'SQL 개발자', en: 'SQL Developer' }, note: 'SQLD' },
    { date: '2020.07', name: { ko: '데이터분석 준전문가', en: 'Advanced Data Analytics Semi-Professional' }, note: 'ADsP' },
    { date: '2025.03', name: { ko: 'OPIc', en: 'OPIc' }, note: 'AL / AL' },
    { date: '2020.02', name: { ko: 'TOEIC', en: 'TOEIC' }, note: '990 / 990' },
  ],
};

export const experience = [
  {
    period: { ko: '2025.12 — 현재', en: '2025.12 — Present' },
    company: { ko: '지마켓', en: 'Gmarket' },
    role: { ko: 'Business Analyst · Business Analytics', en: 'Business Analyst · Business Analytics' },
    points: [
      {
        ko: 'AI를 활용해 전사 주간 경영보고서(WBR)를 Excel에서 웹 대시보드로 전환하고, SQL 추출·개발·배포를 전담하며 글로벌 C-level 보고 지원',
        en: 'Leveraged AI to migrate the company-wide weekly business review (WBR) from Excel to a web dashboard, owning SQL extraction, development, and deployment to support global C-level reporting',
      },
      {
        ko: '주간 지표 이상 신호를 조직·카테고리·셀러·채널 단위로 분해하는 원인 분석 수행',
        en: 'Diagnosed weekly KPI anomalies by breaking them down by organization, category, seller, and channel',
      },
      {
        ko: '상품 운영과 배송·할인 정책을 분석해 관리 지표와 대응 시나리오를 구성하고 정책 검토 지원',
        en: 'Analyzed catalog operations and shipping and discount policies to build management metrics and response scenarios, supporting policy review',
      },
    ],
  },
  {
    period: { ko: '2023.01 — 2025.02', en: '2023.01 — 2025.02' },
    company: { ko: '쿠팡이츠서비스', en: 'Coupang Eats Service' },
    role: { ko: 'Program Management Specialist', en: 'Program Management Specialist' },
    points: [
      {
        ko: '동일한 운영 인력으로 주문량 **2.6배** 처리 가능한 이상 패턴 주문 식별 로직 구축',
        en: 'Designed real-time anomaly detection logic that let the same operations team handle **2.6×** the order volume',
      },
      {
        ko: '대시보드 구축하여 지역별 이상 패턴 원인 파악 및 운영 효율성 증대',
        en: 'Built dashboards that pinpointed regional causes of anomaly patterns, improving operational efficiency',
      },
      {
        ko: '지역 및 시간별 배달비 최대 1,362원(**27%**) 절감 및 지연 시간 단축',
        en: 'Cut delivery costs by up to KRW 1,362 (**27%**) by region and time slot while reducing delivery delays',
      },
    ],
  },
  {
    period: { ko: '2022.03 — 2023.01', en: '2022.03 — 2023.01' },
    company: { ko: '버즈빌', en: 'Buzzvil' },
    role: { ko: 'Monetization Operations Manager', en: 'Monetization Operations Manager' },
    points: [
      {
        ko: '특정 광고 상품 CTR 80%, eCPM 1,600원을 달성하여 최종 매출 **75%** 증대',
        en: 'Increased final revenue by **75%** by achieving 80% CTR and a KRW 1,600 eCPM on a key ad product',
      },
      {
        ko: '논리워드 네트워크 단가 최적화를 통해 eCPM **127%**, 매출 **156%** 증대',
        en: 'Optimized non-reward network pricing, increasing eCPM by **127%** and revenue by **156%**',
      },
      {
        ko: '해외 미수채권 직접 회수 및 표준 계약서 재정립을 통한 재무 건전성 강화',
        en: 'Strengthened financial soundness by collecting overseas receivables and redefining standard contracts',
      },
      {
        ko: '뉴스 콘텐츠 가이드라인 제작으로 운영 시간 **63%** 단축',
        en: 'Cut operating time by **63%** by creating news content guidelines',
      },
    ],
  },
  {
    period: { ko: '2018.11 — 2019.08', en: '2018.11 — 2019.08' },
    company: { ko: '카카오', en: 'Kakao' },
    role: { ko: '메시지광고/검색광고사업팀 어시스턴트 (계약직)', en: 'Advertising, Product Owner Assistant (Fixed-term)' },
    points: [
      {
        ko: '30만 건의 키워드 분석하고 상위 카테고리 재편하여 특정 카테고리 CTR **10%** 개선',
        en: 'Analyzed 300K keywords and restructured top-level categories, improving CTR by **10%** in target categories',
      },
      {
        ko: '외부 파트너 제휴를 위한 키워드 비교 분석 및 변수, 기기별 테스트를 통해 ROAS **465%** 달성',
        en: 'Achieved **465%** ROAS through keyword comparison analysis for external partnerships and variable- and device-level testing',
      },
      {
        ko: '광고 가이드라인용 이미지 추출 자동화 툴 제안으로 클릭 점유율 최대 **82%** 향상',
        en: 'Proposed an automated image-extraction tool for ad guidelines, increasing click share by up to **82%**',
      },
    ],
  },
  {
    period: { ko: '2018.06 — 2018.09', en: '2018.06 — 2018.09' },
    company: { ko: '서울대학교 데이터마이닝센터', en: 'Seoul National University Data Mining Center' },
    role: { ko: '연구 인턴', en: 'Research Assistant (Intern)' },
    points: [
      {
        ko: 'Python 크롤링을 활용한 인스타그램 데이터 마이닝으로 핫플레이스 기반 상가건물 변동성 예측 프로젝트 연구 지원',
        en: 'Supported research predicting commercial-building value volatility around trending places by mining Instagram data with Python crawlers',
      },
    ],
  },
  {
    period: { ko: '2018.04 — 2018.06', en: '2018.04 — 2018.06' },
    company: { ko: 'SNOW', en: 'SNOW' },
    role: { ko: '서비스 기획 인턴', en: 'N studio, Contents Specialist (Intern)' },
    points: [
      {
        ko: '유저 분석 기반 콘텐츠 제작 및 마케팅을 통해 iOS 영어 교육 부문 **1위** 달성',
        en: 'Reached **#1** in the iOS English-education category through user-analysis-driven content and marketing',
      },
    ],
  },
  {
    period: { ko: '2015.07 — 2015.08', en: '2015.07 — 2015.08' },
    company: { ko: '한샘', en: 'Hanssem' },
    role: { ko: '제품 개발 인턴', en: 'Product Development (Intern)' },
    points: [
      {
        ko: '온라인 큐레이션 서비스를 제안하고 이를 웹사이트와 프로모션 전략으로 실제 한샘에서 실행',
        en: 'Proposed an online curation service that Hanssem implemented in its website and promotion strategy',
      },
    ],
  },
];

const GMARKET = { ko: '지마켓', en: 'Gmarket' };
const COUPANG = { ko: '쿠팡이츠', en: 'Coupang Eats' };

/*
 * slides: 포트폴리오 PDF 페이지 이미지(public/slides/, 영문은 public/slides/en/)
 *   지마켓 슬라이드(gmarket_*)는 같은 양식으로 새로 그린 것으로, 화면은 수치 없이 재구성하고 비율만 담았다
 * confidential: 사내 데이터라 수치를 비율로만 공개한다는 안내를 붙인다
 */
export const projects = [
  {
    id: 'wbr-automation',
    name: { ko: '주간 경영보고서(WBR) 자동화', en: 'Weekly Business Review (WBR) Automation' },
    org: GMARKET,
    period: { ko: '2026 — 현재', en: '2026 — Present' },
    summary: {
      ko: 'AI를 활용해 전사 주간 경영보고서를 Excel에서 Google Apps Script 웹 대시보드로 전환하고, SQL 추출부터 개발·CI/CD까지 전담하며 글로벌 C-level 보고를 지원합니다.',
      en: 'Leveraged AI to migrate the company-wide weekly business review from Excel to a Google Apps Script web dashboard, owning everything from SQL extraction to development and CI/CD to support global C-level reporting.',
    },
    metric: { value: { ko: '10회', en: '10 releases' }, label: { ko: '13주간 기능 배포', en: 'in 13 weeks' } },
    role: { ko: '분석 · 개발 · 운영', en: 'Analysis · Dev · Ops' },
    results: [
      {
        ko: 'Google Apps Script 대시보드 설계·개발, 코드 관리와 CI/CD 구축',
        en: 'Designed and built the Google Apps Script dashboard with code management and CI/CD',
      },
      {
        ko: '13주간 **10차례** 기능 배포(G마켓·옥션 분리 보기, 반품률 섹션 등)',
        en: 'Shipped **10** feature releases in 13 weeks (Gmarket/Auction split view, return-rate section, and more)',
      },
      {
        ko: '조직별 목표 달성률·Pacing·Health와 KPI 트리(방문 → 조회 → 구매 전환 → 객단가) 운영',
        en: 'Runs organization-level target attainment, pacing, and health tracking on a KPI tree (visits → views → purchase conversion → AOV)',
      },
    ],
    skills: ['SQL', 'Databricks', 'Google Apps Script', 'JavaScript', 'CI/CD'],
    slides: ['gmarket_wbr_1.png', 'gmarket_wbr_2.png'],
    confidential: true,
  },
  {
    id: 'gmv-decline',
    name: { ko: 'GMV 역성장 원인 규명', en: 'GMV Decline Driver Analysis' },
    org: GMARKET,
    period: '2026.09',
    summary: {
      ko: '조회 고객이 늘었음에도 전환율 하락이 갭의 약 2/3를 차지함을 규명하고, 상위 10개 셀러 집중(갭의 70%)을 확인했습니다.',
      en: 'Showed that falling conversion drove about two-thirds of the gap despite more viewing customers, with the top 10 sellers accounting for 70%.',
    },
    metric: { value: { ko: '약 2/3', en: '≈ 2/3' }, label: { ko: '갭 중 전환율 하락', en: 'of the gap from conversion' } },
    role: { ko: '분석', en: 'Analysis' },
    results: [
      { ko: '전환율 하락이 갭의 **약 2/3**임을 규명', en: 'Falling conversion drove **about two-thirds** of the gap' },
      { ko: '상위 10개 셀러가 갭의 **70%**', en: 'The top 10 sellers accounted for **70%** of the gap' },
    ],
    skills: ['SQL', 'Databricks', 'Excel'],
    slides: ['gmarket_gmv_1.png', 'gmarket_gmv_2.png'],
    confidential: true,
  },
  {
    id: 'catalog-policy',
    name: { ko: '상품 운영·정책 분석', en: 'Catalog & Policy Analysis' },
    org: GMARKET,
    period: '2026.04 — 2026.08',
    summary: {
      ko: '상품 운영과 배송·할인 정책을 분석해 관리 지표와 대응 시나리오를 구성했습니다.',
      en: 'Analyzed catalog operations and shipping and discount policies to build management metrics and response scenarios.',
    },
    metric: { value: { ko: '4종', en: '4' }, label: { ko: '상품 관리 지표', en: 'item-management metrics' } },
    role: { ko: '분석 · 지표 · 시나리오 설계', en: 'Analysis · Metrics · Scenarios' },
    results: [
      {
        ko: '등록 상품의 1% 미만만 판매되는 롱테일 구조를 진단하고, 상품 이탈·신규·유지별 GMV 변화와 조회·전환이 없는 상품을 셀러 등급별로 분석해 상품 관리 지표 **4종**을 구성, 월간 대시보드로 구현',
        en: 'Diagnosed a long-tail catalog in which under 1% of listed items sell, and analyzed GMV change across churned, new, and retained items and items with no views or conversions by seller tier to build **four** item-management metrics on a monthly dashboard',
      },
      {
        ko: '무료배송 기준 변경의 GMV 영향 상한과 할인 예산 재배분 효율을 분석해 정책별 대응 시나리오 구성',
        en: 'Analyzed the upper-bound GMV impact of free-shipping threshold changes and the efficiency of reallocating discount budgets to build response scenarios for each policy',
      },
    ],
    skills: ['SQL', 'Dashboard', 'Chart.js', 'Scenario Modeling'],
    slides: ['gmarket_item_1.png', 'gmarket_item_2.png'],
    confidential: true,
  },
  {
    id: 'traffic-cancellation',
    name: { ko: '트래픽·취소 이상 신호 분석', en: 'Traffic & Cancellation Anomaly Analysis' },
    org: GMARKET,
    period: '2026.08',
    summary: {
      ko: '주간 평균에 가려진 방문자 감소와 취소 급증의 원인을 채널·고객 등급·카테고리 단위로 분해했습니다.',
      en: 'Traced a visitor decline and a cancellation spike hidden in weekly averages down to channel, customer tier, and category.',
    },
    role: { ko: '분석', en: 'Analysis' },
    results: [
      {
        ko: '방문자 감소를 채널·고객 등급별로 분해해 특정 유입 채널의 할인 예산 축소가 비활성 고객 유입 감소로 이어졌음을 제시',
        en: 'Broke down a visitor decline by channel and customer tier, showing that a discount-budget cut on one acquisition channel reduced inflow from inactive customers',
      },
      {
        ko: '주간 평균에 가려진 일자별 취소 급증을 일자·카테고리 3단계로 분석해 급증 카테고리 특정',
        en: 'Drilled a daily cancellation spike hidden in the weekly average down three category levels to pinpoint where it came from',
      },
    ],
    skills: ['SQL', 'Segmentation', 'Chart.js'],
    slides: ['gmarket_traffic_1.png', 'gmarket_traffic_2.png'],
    confidential: true,
  },
  {
    id: 'anomaly-detection',
    name: { ko: '이상 패턴 식별 시스템', en: 'Anomaly Pattern Identification System' },
    org: COUPANG,
    period: '2024.01 — 2024.07',
    summary: {
      ko: '이상 패턴 주문을 실시간으로 식별하고 처리할 수 있는 시스템을 구축했습니다. SQL 로직 구현 후 머신러닝을 도입하여 운영 효율을 극대화했습니다.',
      en: 'Built a system that identifies and handles anomalous orders in real time, starting with SQL logic and then adding machine learning to maximize operational efficiency.',
    },
    metric: { value: { ko: '2.6배', en: '2.6×' }, label: { ko: '동일 인력 처리량', en: 'orders, same team' } },
    role: { ko: '기획 · 분석 · 개발 · 운영', en: 'Product · Analysis · Dev · Ops' },
    results: [
      { ko: '동일 인력으로 주문 처리량 **2.6배**', en: 'Handled **2.6×** the order volume with the same headcount' },
      { ko: 'Precision/Recall **98%**, AUC **0.93** 달성', en: 'Achieved **98%** precision/recall and **0.93** AUC' },
      { ko: '이상 패턴 주문 **70% 이상** 실시간 식별', en: 'Identified **70%+** of anomalous orders in real time' },
    ],
    skills: ['SQL', 'Python', 'Machine Learning'],
    slides: ['slide_3.png', 'slide_4.png', 'slide_5.png'],
  },
  {
    id: 'backoffice',
    name: { ko: '백오피스 플랫폼 기획', en: 'Back-office Platform Planning' },
    org: COUPANG,
    period: '2023.08 — 2023.12',
    summary: {
      ko: '운영 효율화를 위한 백오피스 플랫폼을 기획하고 대시보드를 구축했습니다. 데이터 기반으로 의사결정 프로세스를 자동화했습니다.',
      en: 'Planned a back-office platform for operational efficiency and built its dashboards, automating data-driven decision processes.',
    },
    metric: { value: { ko: '3배', en: '3×' }, label: { ko: '운영 안정성', en: 'operational stability' } },
    role: { ko: '기획 · 분석', en: 'Product · Analysis' },
    results: [
      { ko: '운영 안정성 **3배** 개선', en: 'Improved operational stability **3×**' },
      { ko: '데이터 기반 실시간 모니터링 체계 구축', en: 'Built a data-driven real-time monitoring system' },
    ],
    skills: ['SQL', 'Data Analysis', 'Figma'],
    slides: ['slide_6.png', 'slide_7.png'],
  },
  {
    id: 'ops-policy',
    name: { ko: '운영 정책 방안 기획', en: 'Operations Policy Planning' },
    org: COUPANG,
    period: '2023.01 — 2023.07',
    summary: {
      ko: '서비스 안정화를 위한 운영 정책을 수립하고 시스템에 반영했습니다. 배달 파트너 및 유저 경험 최적화를 목표로 했습니다.',
      en: 'Developed operational policies for service stabilization and built them into the system, aiming to optimize the delivery-partner and user experience.',
    },
    role: { ko: '기획 · 운영', en: 'Product · Ops' },
    results: [
      { ko: '운영 정책 도입 후 클레임 **30%** 감소', en: 'Reduced claims by **30%** after the new policies' },
      { ko: '배달 효율성 **15%** 증대', en: 'Increased delivery efficiency by **15%**' },
    ],
    skills: ['Product', 'Data Analysis'],
    slides: ['slide_8.png', 'slide_9.png'],
  },
  {
    id: 'ad-service',
    name: { ko: '광고 서비스 개선', en: 'Ad Service Improvement' },
    org: { ko: '버즈빌', en: 'Buzzvil' },
    period: '2022.03 — 2023.01',
    summary: {
      ko: '리워드 광고 서비스의 성과 분석 및 지면 최적화를 통해 매출을 증대시켰습니다. SQL 기반 데이터 분석으로 핵심 KPI를 관리했습니다.',
      en: 'Grew revenue through performance analysis and inventory optimization of reward ad services, managing key KPIs with SQL-based analysis.',
    },
    metric: { value: { ko: '75% ↑', en: '75% ↑' }, label: { ko: '광고 매출', en: 'ad revenue' } },
    role: { ko: '분석 · 운영', en: 'Analysis · Ops' },
    results: [
      { ko: '광고 매출 **75%** 성장', en: 'Grew ad revenue by **75%**' },
      { ko: 'CTR **80%** 달성', en: 'Achieved **80%** CTR' },
    ],
    skills: ['SQL', 'Data Analysis', 'AdTech'],
    slides: ['slide_10.png', 'slide_11.png'],
  },
  {
    id: 'cake',
    name: { ko: 'CAKE 영어 교육 앱', en: 'CAKE English Education App' },
    org: { ko: 'SNOW', en: 'SNOW' },
    period: '2018.04 — 2018.06',
    summary: {
      ko: '유저 분석 기반 콘텐츠 제작 및 마케팅을 통해 iOS 영어 교육 부문 1위를 달성했습니다. 2030 여성 중고급 회화 사용자 타겟 및 시장 분석에 따른 주제 및 영상 선정을 진행했습니다.',
      en: 'Reached #1 in the iOS English-education category through user-analysis-driven content and marketing, selecting topics and videos from market analysis of women in their 20s–30s at intermediate-to-advanced levels.',
    },
    metric: { value: { ko: '1위', en: '#1' }, label: { ko: 'iOS 영어 교육', en: 'iOS English Education' } },
    role: { ko: '기획 · 마케팅', en: 'Product · Marketing' },
    results: [
      { ko: 'iOS 영어 교육 부문 **1위** 달성', en: 'Reached **#1** in the iOS English-education category' },
      { ko: '마케팅 플랜 시각화로 디자인팀과 협업 체계 구축', en: 'Visualized the marketing plan to build a collaboration workflow with the design team' },
    ],
    skills: ['User Analysis', 'Marketing', 'Content Planning'],
  },
  {
    id: 'duredure',
    name: { ko: '두레두레', en: 'DureDure' },
    org: { ko: '농식품 빅데이터 창업경진대회', en: 'Agri-Food Big Data Startup Competition' },
    period: '2020',
    summary: {
      ko: '농식품 빅데이터를 활용한 창업 아이디어로 최우수상을 수상했습니다. 데이터 분석을 통해 농산물 유통 최적화 솔루션을 제안했습니다.',
      en: 'Won the Grand Prize with a startup idea built on agri-food big data, proposing an agricultural distribution optimization solution through data analysis.',
    },
    metric: { value: { ko: '최우수상', en: 'Grand Prize' }, label: { ko: '공공데이터 부문', en: 'Public Data track' } },
    role: { ko: '기획 · 분석', en: 'Product · Analysis' },
    results: [
      { ko: '농식품 빅데이터 창업경진대회 **최우수상**', en: '**Grand Prize** at the Agri-Food Big Data Startup Competition' },
      { ko: '데이터 기반 농산물 유통 최적화 솔루션 제안', en: 'Proposed a data-driven agricultural distribution optimization solution' },
    ],
    skills: ['Data Analysis', 'Python', 'Business Planning'],
  },
];

export const skillGroups = [
  {
    name: 'Data Analysis',
    desc: { ko: '데이터를 추출하고 원인을 분해합니다', en: 'Extract data and break down root causes' },
    rows: [
      { label: { ko: '언어 · 도구', en: 'Languages & Tools' }, items: ['SQL', 'Databricks', 'Python', 'Excel', 'BigQuery'] },
      {
        label: { ko: '분석 방법', en: 'Methods' },
        items: ['A/B Testing', 'K-means Clustering', 'Factor Analysis', 'Machine Learning', 'Statistical Analysis', 'Data Mining'],
      },
    ],
  },
  {
    name: 'Reporting & Automation',
    desc: { ko: '분석을 반복 가능한 리포트와 대시보드로 만듭니다', en: 'Turn analysis into repeatable reports and dashboards' },
    rows: [
      {
        label: { ko: '대시보드', en: 'Dashboards' },
        items: ['Google Apps Script', 'JavaScript', 'Grafana', 'Redash', 'Google Sheets'],
      },
      { label: { ko: '배포', en: 'Delivery' }, items: ['CI/CD'] },
    ],
  },
  {
    name: 'Collaboration & Language',
    desc: { ko: '여러 팀, 글로벌 환경과 함께 일합니다', en: 'Work across teams and languages' },
    rows: [
      { label: { ko: '협업 도구', en: 'Tools' }, items: ['Jira', 'Slack', 'Notion', 'Figma'] },
      { label: { ko: '영어', en: 'English' }, items: ['TOEIC 990', 'OPIc AL'] },
    ],
  },
];

export const awards = [
  {
    year: '2020',
    name: { ko: '농식품 공공 빅데이터 활용 창업경진대회 최우수상', en: 'Grand Prize, Agri-Food Public Big Data Startup Competition' },
    note: { ko: '아이디어 기획 · 공공데이터 부문', en: 'Ideation · Public Data track' },
  },
  {
    year: '2016',
    name: { ko: 'Judges’ Choice', en: 'Judges’ Choice' },
    note: { ko: 'DFK, 연세대학교', en: 'Design Factory Korea (DFK), Yonsei University' },
  },
];

export const activities = [
  {
    period: '2021',
    name: { ko: 'LG생활건강 온더바디 마케팅 서포터즈', en: 'LG Household & Health Care OntheBody Marketing Supporters' },
  },
  {
    period: '2020',
    name: { ko: '아모레퍼시픽 에뛰드 마케팅 서포터즈', en: 'AMOREPACIFIC Etude Marketing Supporters' },
  },
];

export const nav = {
  about: { ko: '소개', en: 'About' },
  experience: { ko: '경력', en: 'Experience' },
  projects: { ko: '프로젝트', en: 'Projects' },
  skills: { ko: '기술', en: 'Skills' },
  awards: { ko: '수상·활동', en: 'Awards' },
  contact: { ko: '연락처', en: 'Contact' },
};

export const labels = {
  education: { ko: '학력', en: 'Education' },
  certifications: { ko: '자격 · 어학', en: 'Certifications' },
  role: { ko: '역할', en: 'Role' },
  results: { ko: '주요 성과', en: 'Key results' },
  slides: { ko: '포트폴리오 슬라이드', en: 'Portfolio slides' },
  viewDetail: { ko: '자세히 보기', en: 'View details' },
  closeDetail: { ko: '접기', en: 'Collapse' },
  enlarge: { ko: '크게 보기', en: 'Enlarge' },
  confidential: {
    ko: '사내 데이터 보호를 위해 수치는 비율로만 공개합니다',
    en: 'Figures are shown as ratios only to protect internal data',
  },
  awardsTitle: { ko: '수상', en: 'Awards' },
  activitiesTitle: { ko: '활동', en: 'Activities' },
  resumeKo: { ko: '국문 이력서', en: 'Résumé (Korean)' },
  resumeEn: { ko: '영문 이력서', en: 'Résumé (English)' },
  contactTitle: { ko: '함께 일해요', en: 'Let’s work together' },
  contactDesc: {
    ko: '프로젝트 협업이나 채용 제안을 기다리고 있습니다.',
    en: 'I’m open to new projects and job opportunities.',
  },
  prev: { ko: '이전', en: 'Previous' },
  next: { ko: '다음', en: 'Next' },
  close: { ko: '닫기', en: 'Close' },
  backToTop: { ko: '맨 위로', en: 'Back to top' },
};
